import React, { useState } from "react";
// import { AxiosInstance } from "../../../common/Loader/axios.config";
import Swal from "sweetalert2";
import { IoClose } from "react-icons/io5";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { AxiosInstance } from "../../../../common/Loader/axios.config";

const EditProviderModal = ({ isOpen, onClose, selectedProvider, fetchProviders }) => {
  const [formData, setFormData] = useState({
    name: selectedProvider.name,
    description: selectedProvider.description,
    price: selectedProvider.price,
    category: selectedProvider.category,
  });

//   const AxiosInstance = axios.create({
//     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
// });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    AxiosInstance.put(`/${selectedProvider._id}/provider`, formData)
      .then((response) => {
        console.log("Provider Update Response", response);
        if (response.data.status === "success") {
          const contentId = response.data.message._id;
          Swal.fire({
            icon: "success",
            title: "Content Updated successfully! ",
            text: `${selectedProvider.name} has been updated successfully!`,
            showConfirmButton: false,
            timer: 2000,
          });
          onClose();
          setLoading(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to update provider",
            text: `${response.data.message}`,
            showConfirmButton: false,
            timer: 2000,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Failed to update provider",
          text: "An error occurred while updating the provider.",
        });
        setLoading(false);
      });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative w-1/2 rounded-lg bg-brand-background p-6">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-2xl text-white"
        >
          <IoClose />
        </button>
        <h2 className="mb-4 text-lg font-semibold text-white">Edit Provider</h2>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 text-black"
        >
          <div>
            <label className="mb-2 block text-white">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-white">Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-white">Price</label>
            <input
              type="text"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            />
          </div>

          <div>
            <label className="mb-2 block text-white">Category</label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            >
              <option value="">Select Category...</option>
              <option value="tv">TV</option>
              <option value="vod">Video</option>
              <option value="event">Event</option>
              <option value="shorts">Shorts</option>
              <option value="series">Series</option>
            </select>
          </div>
          <div className="col-span-2">
            <button
              type="submit"
              className="rounded bg-primary px-4 py-2 text-white"
            >
              {loading ? <ClipLoader size={20} color="#FFFFFF" /> : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProviderModal;
